import "magnific-popup";

class Magnific {
    image = { type: 'image' }
    gallery = {
        delegate: 'a',
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-no-margins mfp-with-zoom',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            verticalFit: true,
            titleSrc: function(item) {
                return `${item.el.attr('title')}`;
            }
        },
        zoom: {
            enabled: true,
            duration: 300 // don't foget to change the duration also in CSS
        }
    }

    inline = {
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        mainClass: 'my-mfp-slide-bottom'
    }

    iframe = {
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    }

    popups = null

    constructor($selector) {
        this.popups = $selector
    }

    initialize () {
        for(var i = 0; i < this.popups.length; i++)
        {
            let popup = this.popups.item(i);
            let type  = popup.dataset.mfpType;

            console.log(type);
            $(popup).magnificPopup(this[type]);
        }
    }

}

export default Magnific;

